import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

const getMoodTrackerState = (state: RootState) => state.moodTracker;

export const selectMoods = createSelector(
  [getMoodTrackerState],
  (moodTrackerState) => moodTrackerState.moods
);

export const selectProfileMoods = createSelector(
  [getMoodTrackerState],
  (moodTrackerState) => moodTrackerState.profileMoods
);

export const selectAveragePerDayForMoods = createSelector(
  [getMoodTrackerState],
  (moodTrackerState) => moodTrackerState.averagePerDayForMoods
);

export const selectIsLoadingMoods = createSelector(
  [getMoodTrackerState],
  (moodTrackerState) => moodTrackerState.loadingMoods
);

export const selectIsLoadingCreateMood = createSelector(
  [getMoodTrackerState],
  (moodTrackerState) => moodTrackerState.loadingCreateMood
);

export const selectPendingMood = createSelector(
  [getMoodTrackerState],
  (moodTrackerState) => moodTrackerState.pendingMood
);
